import { useEffect, useMemo } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import { COMMAND_PRIORITY_CRITICAL, SELECTION_CHANGE_COMMAND } from "lexical";
import { useWormholeSources } from "../../../../hooks/index.js";
import { UPDATE_TOOLBAR_COMMAND, useEditorData } from "../../context/index.js";
const groupSortOrder = ["history", "fontFamily", "fontSize", "fontFormat", "paragraphFormat", "misc"];
function sortToolbarGroups(a, b) {
  const groupA = a.meta?.groupId ?? "";
  const groupB = b.meta?.groupId ?? "";
  const idxA = groupSortOrder.indexOf(groupA);
  const idxB = groupSortOrder.indexOf(groupB);
  if (idxA === -1 && idxB === -1) {
    return 0;
  }
  if (idxA === -1) {
    if (b.id === "misc") return -1;
    return 1;
  }
  if (idxB === -1) {
    if (a.id === "misc") return 1;
    return -1;
  }
  return idxA - idxB;
}
function useToolbarGroups() {
  const { toolbarTarget } = useEditorData();
  const [editor] = useLexicalComposerContext();
  const [wormholes] = useWormholeSources(toolbarTarget);
  const toolbarGroups = useMemo(() => wormholes.slice().sort(sortToolbarGroups), [wormholes]);
  useEffect(() => {
    toolbarGroups;
    return mergeRegister(
      editor.registerCommand(
        SELECTION_CHANGE_COMMAND,
        (_, newEditor) => {
          newEditor.dispatchCommand(UPDATE_TOOLBAR_COMMAND, void 0);
          return false;
        },
        COMMAND_PRIORITY_CRITICAL
      ),
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          editor.dispatchCommand(UPDATE_TOOLBAR_COMMAND, void 0);
        });
      })
    );
  }, [editor, toolbarGroups]);
  return toolbarGroups;
}
export {
  sortToolbarGroups,
  useToolbarGroups
};
//# sourceMappingURL=useToolbarGroups.js.map
